import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="product-customization"
export default class extends Controller {
  static values = {
    variantId: Number,
  };

  static targets = [
    "inputsContainer",
    "heart",
    "chest",
    "back",
    "leftSleeve",
    "rightSleeve",
  ];

  connect() {
    this.loadCustomizationFromStorage();
  }

  toggleInputsContainer() {
    if (this.hasInputsContainerTarget) {
      this.inputsContainerTarget.classList.toggle("hidden");
    }
  }

  customizationParams() {
    return {
      heart: this.hasHeartTarget ? this.heartTarget.value || "" : "",
      chest: this.hasChestTarget ? this.chestTarget.value || "" : "",
      back: this.hasBackTarget ? this.backTarget.value || "" : "",
      leftSleeve: this.hasLeftSleeveTarget ? this.leftSleeveTarget.value || "" : "",
      rightSleeve: this.hasRightSleeveTarget ? this.rightSleeveTarget.value || "" : "",
    };
  }

  persistCustomizationToStorage() {
    localStorage.setItem(
      this.storageKey(),
      JSON.stringify(this.customizationParams())
    );
  }

  loadCustomizationFromStorage() {
    let customization = localStorage.getItem(this.storageKey());

    if (customization) {
      customization = JSON.parse(customization);
      if (this.hasHeartTarget) this.heartTarget.value = customization.heart || "";
      if (this.hasChestTarget) this.chestTarget.value = customization.chest || "";
      if (this.hasBackTarget) this.backTarget.value = customization.back || "";
      if (this.hasLeftSleeveTarget) this.leftSleeveTarget.value = customization.leftSleeve || "";
      if (this.hasRightSleeveTarget) this.rightSleeveTarget.value = customization.rightSleeve || "";
    }
  }

  storageKey() {
    return `variant-${this.variantIdValue}-customization`;
  }
}
